module.exports = __webpack_public_path__ + "img/ic_checkbox.db41fa79.svg";